<div>
  <span *ngIf="isLongValue()"><fa-icon icon="eye" size="sm" [title]="externalId"></fa-icon></span>
  {{ externalId | externalIdentifier }}
</div>
